<div class="header-label">Job Review</div>
<div class="flex-fill d-flex flex-column content-block dx-card p-3">
  @if (true) {
    <div class="content-block dx-card responsive-paddings" autofocus>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end">Time Limit</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="filter"></dx-number-box>
        <button class="btn btn-primary me-2" (click)="search()">Search</button>
      </div>
    </div>
  }
  <div class="flex-fill d-flex flex-column content-block dx-card p-3">
    <div class="flex-fill d-flex flex-column">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="100px"
        [dataSource]="jobs"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="rowDoubleClick($event)"
        >
        <dxi-data-grid-column
          dataField="id"
          caption="Job #"
          width="80"
          [sortIndex]="1"
          [sortOrder]="'desc'"
          [alignment]="'left'"
        ></dxi-data-grid-column>
        <dxi-data-grid-column dataField="startDate" caption="Date" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="_totalTime" caption="Time (mins)" width="120" [format]="{ precision: 2 }"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rental.customer.displayName" caption="Customer" width="200"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobType.name" caption="Job Type" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="action.name" width="150" caption="Action"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driver.displayName" caption="Driver" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="weight" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="started" format="shortDateShortTime" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" format="shortDateShortTime" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="siteName" caption="Site" width="250"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayAddress" caption="Service Address" width="250"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driverNotes" width="350"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="job-review-grid"></dxo-data-grid-state-storing>

        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            class="btn btn-primary me-2 mb-2"
            (click)="openJobTimes(dataGrid.instance.getSelectedRowsData()[0].id)"
            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
            >
            Open Job Times
          </button>
          <button
            class="btn btn-success me-2 mb-2"
            (click)="setJobTimes(dataGrid.instance.getSelectedRowsData())"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
            >
            Set Job Time
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (jobs) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
